import { takeLatest, put, call, all } from 'redux-saga/effects';
import { Action } from 'redux-actions';

import { GoogleSsoConfig } from '@api/types';
import { getSsoSettings, createSsoSettings, parseGoogleIdp, updateSsoSettings } from '@api/ssoSettings';
import {
  DATA_FETCH_STARTED,
  DATA_CREATE_STARTED,
  DATA_UPDATE_STARTED,
  SETTINGS_PARSING_STARTED,
  fetchDataSucceeded,
  createDataSucceeded,
  createDataFailed,
  updateDataSucceeded,
  updateDataFailed,
  parseSettingsSucceeded,
  parseSettingsFailed,
} from '@redux/ducks/ssoConfiguration/googleSso';

// Workers

export function* fetchDataTask() {
  try {
    const settingsResp = yield call(getSsoSettings);

    yield put(fetchDataSucceeded(settingsResp));
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(err);
  }
}

export function* createDataTask({ payload }: Action<GoogleSsoConfig>) {
  try {
    yield call(createSsoSettings, payload);
    yield put(createDataSucceeded());
  } catch (err) {
    yield put(createDataFailed(err.data));
  }
}

export function* updateDataTask({ payload }: Action<GoogleSsoConfig>) {
  try {
    yield call(updateSsoSettings, payload);
    yield put(updateDataSucceeded());
  } catch (err) {
    yield put(updateDataFailed(err.data));
  }
}

export function* parseSettingsTask({ payload }: Action<File>) {
  try {
    const resp = yield call(parseGoogleIdp, payload);

    yield put(parseSettingsSucceeded(resp));
  } catch (err) {
    yield put(parseSettingsFailed(err.data));
  }
}

// Watchers

export function* watchFetchData() {
  yield takeLatest(DATA_FETCH_STARTED, fetchDataTask);
}

export function* watchCreateData() {
  yield takeLatest(DATA_CREATE_STARTED, createDataTask);
}

export function* watchUpdateData() {
  yield takeLatest(DATA_UPDATE_STARTED, updateDataTask);
}

export function* watchParseSettings() {
  yield takeLatest(SETTINGS_PARSING_STARTED, parseSettingsTask);
}

// Saga

export default function* googleSsoSaga() {
  yield all([watchFetchData(), watchCreateData(), watchUpdateData(), watchParseSettings()]);
}
